module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-file@2x-f8d3ed4d489a1007ac0eee51896f38b3.png";